"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Page;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIListingPage = _interopRequireDefault(require("UIComponents/page/UIListingPage"));

var _Header = _interopRequireDefault(require("./Header"));

function Page(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_UIListingPage.default, {
    pageLayout: "max-width",
    children: children,
    headerComponent: _react.default.createElement(_Header.default, null)
  });
}

Page.propTypes = {
  children: _propTypes.default.node
};
module.exports = exports.default;